import { useState, useEffect } from "react";
import { Collapse, message, Modal } from 'antd';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Map from "../Components/Map";
import EmailImage from "../Assets/email.png";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

const { Panel } = Collapse;

function FAQs() {
  const [FaqsData, setFaqsData] = useState('')
  const [AccordianData, setAccordianData] = useState('')
  const [Email, setEmail] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ADDModalVisible, setADDModalVisible] = useState(false);
  const [UpdateModalVisible, setUpdateModalVisible] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const [Question, setQuestion] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }


  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "FAQS"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setFaqsData(data.doc)
      })

    fetch(`${url}/page/getallaccordians`)
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setAccordianData(data.doc)
      })
  }

  const OnEmailSubmit = () => {
    if (Email === '') {
      message.error('Fill Field Correctly')
    } else {
      fetch(`${url}/page/addsubscriber`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            email: Email
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('Thank You')
            setEmail('')
          }
        })
    }
  }


  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    }
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
    )
  }

  const handleCancel = () => {
    setTextModalVisible(false);
    setADDModalVisible(false);
    setUpdateModalVisible(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const ShowADDModal = () => {
    setADDModalVisible(true)
  }

  const ShowUpdateModal = (id,question,text) => {
    setUpdateModalVisible(true)
    setHeadingUpdate(question)
    setQuestion(text)
    setUpdateId(id)
  }

  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }

  const OnFAQsDelete = (id) => {
    console.log(id)
    fetch(`${url}/page/deleteaccordian`, {
      method: 'Delete',
      body: JSON.stringify({
        id: id,
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const ADDHandle = () => {
    if (Question === '' || HeadingUpdate === '') {
      message.error('Fill All Fields')
    } else {
      fetch(`${url}/page/createfaqaccordian`, {
        method: 'Post',
        body: JSON.stringify({
          data: {
            text: Question,
            question: HeadingUpdate
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            setADDModalVisible(false)
            setHeadingUpdate('')
            setQuestion('')
            UpdateData()
          }
        })
    }
  }


  const UpdateHandle = () => {
    if (Question === '' || HeadingUpdate === '') {
      message.error('Fill All Fields')
    } else {
      fetch(`${url}/page/updateaccordian`, {
        method: 'Post',
        body: JSON.stringify({
            id: UpdateId,
            text: Question,
            question: HeadingUpdate
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            setUpdateModalVisible(false)
            setHeadingUpdate('')
            setQuestion('')
            UpdateData()
          }
        })
    }
  }



  return (
    <Layout>
      {FaqsData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: FaqsData.section1image1._id,
          headingId: FaqsData.section1heading1._id
        }}
        Image={FaqsData.section1image1.image} />}

      {FaqsData && <div className='Faqs-Container'>
        <h2 className='Heading'>{FaqsData.section2heading1.content}
          <i onClick={() => ShowTextModal(FaqsData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <div className='Faqs-Collapse'>
          <button onClick={ShowADDModal} className='FAQS-add'>Add FAQ's</button>
          
          <Collapse accordion={'true'} expandIconPosition="right">
            {
              AccordianData ? AccordianData.map(data => (
                <Panel className='panel' header={data.question} key={data._id}>
                  <p>{data.text}</p>
                  <button onClick={() => ShowUpdateModal(data._id , data.question , data.text)} className='Update-btn'> Edit </button>
                  <button onClick={() => OnFAQsDelete(data._id )} className='Delete-btn'> Delete </button>
                </Panel>

              )) : <></>
            }
          </Collapse>
        </div>
      </div>
      }
      {FaqsData && <div className='Storage-email-container'>
        <h2>SUBSCRIBE OUR NEWSLETTER & GET UPDATES</h2>
        <div className='Storage-input-div'>
          <img src={EmailImage} draggable='false' alt='Icon' />
          <input value={Email} onChange={e => setEmail(e.target.value)} placeholder='Email Subscriber' />
          <button className='Button' onClick={OnEmailSubmit} >Submit</button>
        </div>
      </div>}
      <Map />
      {
        FaqsData && <GetQuoteForm UpdateImage={UpdateImage} 
        imageID={FaqsData.image._id} image={FaqsData.image.image} />
      }

      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* ADD FAQs Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={ADDModalVisible} onOk={ADDHandle} onCancel={handleCancel} okText="Update" >
        <input value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' style={{ marginBottom: '10px' }} placeholder='Add Question...' />
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={Question} onChange={e => setQuestion(e.target.value)} className='Input' placeholder='Add Text...' />
      </Modal>

      {/* Create FAQs Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={UpdateModalVisible} onOk={UpdateHandle} onCancel={handleCancel} okText="Update" >
        <input value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' style={{ marginBottom: '10px' }} placeholder='Add Question...' />
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={Question} onChange={e => setQuestion(e.target.value)} className='Input' placeholder='Add Text...' />
      </Modal>

    </Layout>
  );
}

export default FAQs;
